var LeafletControlLayersConfig = (function () {
    function LeafletControlLayersConfig(baseLayers, overlays) {
        this.baseLayers = baseLayers;
        this.overlays = overlays;
    }
    return LeafletControlLayersConfig;
}());
export { LeafletControlLayersConfig };
//# sourceMappingURL=leaflet-control-layers-config.model.js.map


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/@asymmetrik/angular2-leaflet/dist/leaflet/layers/control/leaflet-control-layers-config.model.js
// module id = ../../../../@asymmetrik/angular2-leaflet/dist/leaflet/layers/control/leaflet-control-layers-config.model.js
// module chunks = 3